<template>
	<div>
		<el-image :src="basicInfo.nav_background?basicInfo.nav_background:localUrl" style="margin-bottom: -4px;width: 100%;"
			alt="" />
		<headTip></headTip>
		<div>
			<router-view></router-view>
		</div>
		<footerTip></footerTip>
	</div>
</template>

<script>
	import {
		getBasicInfo
	} from '../../api/moudles/user.js'
	import {
		changeFavicon
	} from '../../utils/utils.js'
	import headTip from '../../components/headTip.vue'
	import footerTip from '../../components/footerTip.vue'

	export default {
		data() {
			return {
				basicInfo: {},
				localUrl: require('@/assets/img/webIndex/banner.jpg')
			}
		},
		components: {
			headTip,
			footerTip
		},
		created() {
			this.getBasicInfo()
		},
		methods: {
			// 获取基本信息
			async getBasicInfo() {
				await getBasicInfo({
					data: {
						column_code: '5F8B3D07-841C-E204-58D9-3FF4BCEE4765'
					},
					success: res => {
						this.basicInfo = res.data
						changeFavicon(res.data.icon)
						localStorage.setItem('webName', res.data.title)
						document.title = res.data.title + '-' + '首页'
					}
				})
			},
		}
	}
</script>

<style scoped>

</style>
